






import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Global from '@/Global.vue'

@Component({
  components: {
    Global
  }
})
export default class Layout extends VueBase {
}
